module.exports = __webpack_public_path__ + "static/media/NRGiScanGreen.66a07bd5.png";